// src/api/settings.api.js
import axiosInstance from './axiosInstance';

/**
 * جلب إعدادات النظام الأساسية
 */
export const fetchSettings = () =>
  axiosInstance.get('/settings/');

/**
 * تحديث إعدادات النظام الأساسية (يدعم FormData لرفع الصور مثل الشعار والبانر)
 */
export const updateSettings = (formData) =>
  axiosInstance.put('/settings/', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

/**
 * تحديث الإعدادات (الفلاتر) الافتراضية لصفحة معينة
 * @param {Object} payload - البيانات المرسلة مثال: { page: "bookings", settings: { status: "all" } }
 */
export const updatePageFilters = (payload) =>
  axiosInstance.post('/settings/page/', payload);

/**
 * إعادة تعيين الفلاتر لصفحة معينة لتصبح كما كانت (الافتراضي من النظام)
 * @param {Object} payload - البيانات المرسلة مثال: { page: "bookings" } أو اتركه فارغاً لإعادة تعيين كل الصفحات
 */
export const resetPageFilters = (payload) =>
  axiosInstance.post('/settings/page/reset/', payload);